module.exports = __webpack_public_path__ + "static/media/women-s-pink-sweatshirt-and-brown-plaid-skirt-794064.8afb8376.jpg";